<template>
  <div class="home">
    <!--<img alt="Vue logo" src="https://cdn.storekit.com/wp-content/uploads/2016/07/logo-3.png" class="mb-4 ml-auto mr-auto">-->
    <div class="flex flex-col center" v-if="amountPence">

      <div class="center">
        <h2 class="text-xl mb-4">Initiating Transaction...</h2>
        <h2 class="text-xl mb-4"><span v-if="amountPence < 0">Refund </span>£{{(amountPence / 100).toFixed(2)}}</h2>
        <!--<div class="flex flex-col items-center">-->
          <!--<svg width="59" height="45" viewBox="0 0 59 45" xmlns="http://www.w3.org/2000/svg"><g fill-rule="nonzero" fill="#394953"><path d="M55.07 22.72H43.64v-2h11.43a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v16.72a1 1 0 0 0 1 1h11.47v2H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h52.07a3 3 0 0 1 3 3v16.72a3 3 0 0 1-3 3z"/><path d="M11.04 10.36h36v2h-36z"/><path d="M40.62 44.95H17.45a3.08 3.08 0 0 1-3-3.15V12.06h2v29.73a1.09 1.09 0 0 0 1 1.15h23.17a1.09 1.09 0 0 0 1-1.15V12.06h2v29.73a3.08 3.08 0 0 1-3 3.16z"/><path d="M19.64 12.06h6.08v30.99h-6.08z"/><circle transform="rotate(-74.25 36.065 13.662)" cx="36.065" cy="13.662" r="2.79"/><path d="M34.68 26.86h2.78v13.38h-2.78z"/></g></svg>-->
        <!--</div>-->
      </div>
      <!--<div class="bg-teal-100 border-t-4 border-teal-500 rounded-b text-teal-900 px-4 py-3 shadow-md" role="alert" v-if="timedOut">-->
        <!--<div class="flex">-->
          <!--<div class="py-1"><svg class="fill-current h-6 w-6 text-teal-500 mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"/></svg></div>-->
          <!--<div>-->
            <!--<p class="font-bold">The transaction timed out.</p>-->
            <!--<p class="text-sm">Closing in {{windowClosingSeconds}}, you can then try again.</p>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
    </div>
    <div class="md:px-8 py-8 md:py-16 mb-4 h-auto text-center" v-else>
      <Spinner />
      <h2 class="text-xl mb-20" v-if="error">Couldn't connect to the terminal <br>Check power and network status </h2>

    </div>

  </div>
</template>

<script>

  import sendToVend from './../js/vendMessages';
  import pollTerminal from './../js/pollTerminal';
  import Spinner from './../components/Spinner'
  const queryString = require('query-string');

export default {
  name: 'payment',
  components: {
    Spinner
  },
  data () {
    return {
      constants,
      amount: null,
      amountParsed: null,
      windowClosingSeconds: 4,
      amountPence: 0,
      retryCount: 0,
      error: false
    }
  },
  created() {
    // sendToVend("SETUP");
    setTimeout( () => {
      this.startTransaction();
    },10);
  },
  methods: {
    startTransaction() {

      // console.log(constants.test)

      // const params = new Map(window.location.search.slice(1).split('&').map(kv => kv.split('=')));
      // console.log(params)
      // let amount = params.get("amount");
      //
      // const parsed = queryString.parse(location.search);
      // let amount = parsed.amount

        var pageURL = decodeURIComponent(window.location.search.substring(1)),
                params = pageURL.split('&'),
                paramName,
                parameters = {}

        params.forEach(function (param) {
          paramName = param.split('=')

          console.log(paramName)

          switch (paramName[0]) {
            case 'amount':
              parameters.amount = paramName[1]
              break
            case 'origin':
              parameters.origin = paramName[1]
              break
            case 'register_id':
              parameters.register_id = paramName[1]
              break
          }
        })

        console.log(parameters)


      this.amount = parameters.amount;
      const amountPence = parseFloat(parameters.amount)*100;
      console.log(amountPence)
      let transactionType = 'SALE';
      let amountParsed = Math.round(Math.abs(amountPence));
      console.log(amountParsed)

      if (amountPence < 0) {
        transactionType = "REFUND";
      }
      console.error(amountParsed)

      let url = "https://uk1.storekitpayments.com/api/v1/pay-at-counter/terminals/" + process.env.VUE_APP_TID + "/transactions";
      let data = {
        "transaction_type": transactionType,
        "currency": "GBP",
        "amount": amountParsed
      };

      let self = this;
      this.axios({
        method: "POST",
        url: url,
        headers: {'Authorization': 'Basic dGVzdDp0ZXN0'},
        data: data
      })
        .then(function (response) {

          pollTerminal(response);
          //
          // setTimeout(()=>{
          //   sendToVend("EXIT")
          // },2000)
        })
        .catch(function (error) {
          console.log(error);
          self.error = true;
          if(self.retryCount < 3) {
            self.retryCount++;
            setTimeout( () => {
              self.startTransaction();
            },2000);
          }
          else {
          setTimeout( () => {
                sendToVend("EXIT");
              },500);
            // sendToVend("EXIT");
          }
        })


    },
  }




}
</script>
